import { render, staticRenderFns } from "./StokeTake.vue?vue&type=template&id=10e9242f&scoped=true&"
import script from "./StokeTake.vue?vue&type=script&lang=js&"
export * from "./StokeTake.vue?vue&type=script&lang=js&"
import style0 from "./StokeTake.vue?vue&type=style&index=0&id=10e9242f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9242f",
  null
  
)

export default component.exports